import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';
import { NacinObracunaComponent } from './nacin-obracuna.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  entryComponents: [NacinObracunaComponent],
  declarations: [NacinObracunaComponent],
  exports: [NacinObracunaComponent],
})
export class NacinObracunaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/nacin-obracuna/nacin-obracuna.module.ts